import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Detect mobile/desktop for responsive behavior
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  const handleDealsClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // Already on landing page, just scroll to hot deals
      const hotDealsSection = document.getElementById('hot-deals');
      if (hotDealsSection) {
        hotDealsSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to landing page and then scroll to hot deals
      navigate('/');
      setTimeout(() => {
        const hotDealsSection = document.getElementById('hot-deals');
        if (hotDealsSection) {
          hotDealsSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };
  
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>

      {/* Navigation Bar */}
      <div 
        className="global-nav-bar" 
        style={{
          marginTop: '40px',
          padding: '12px 0',
          textAlign: 'center',
          background: theme.isDarkMode ? 
            'linear-gradient(to bottom, #181818, #121212)' : 
            'linear-gradient(to bottom, #1a1a1a, #141414)',
          color: '#ccc',
          width: '100%',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'nowrap',
          gap: '0'
        }}
      >
        <a 
          href="/" 
          style={{
            color: '#ccc',
            textDecoration: 'none',
            fontSize: isMobile ? '11px' : '14px',
            padding: isMobile ? '0 6px' : '0 10px',
            transition: 'all 0.2s ease',
            display: 'inline-block'
          }}
          aria-label="Go to Home page"
          onMouseOver={(e) => {
            e.target.style.color = '#fff';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseOut={(e) => {
            e.target.style.color = '#ccc';
            e.target.style.textDecoration = 'none';
          }}
        >
          Home
        </a>
        <span style={{ color: '#666', display: 'inline', fontSize: isMobile ? '10px' : '14px', padding: isMobile ? '0 2px' : '0' }}>|</span>
        <a 
          href="/custom-builder" 
          style={{
            color: '#ccc',
            textDecoration: 'none',
            fontSize: isMobile ? '11px' : '14px',
            padding: isMobile ? '0 6px' : '0 10px',
            transition: 'all 0.2s ease',
            display: 'inline-block'
          }}
          aria-label="Go to Fish Finder Builder page"
          onMouseOver={(e) => {
            e.target.style.color = '#fff';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseOut={(e) => {
            e.target.style.color = '#ccc';
            e.target.style.textDecoration = 'none';
          }}
        >
          Builder
        </a>
        <span style={{ color: '#666', display: 'inline', fontSize: isMobile ? '10px' : '14px', padding: isMobile ? '0 2px' : '0' }}>|</span>
        <a 
          href="/#hot-deals" 
          style={{
            color: '#ccc',
            textDecoration: 'none',
            fontSize: isMobile ? '11px' : '14px',
            padding: isMobile ? '0 6px' : '0 10px',
            transition: 'all 0.2s ease',
            display: 'inline-block'
          }}
          aria-label="View today's hottest deals"
          onClick={handleDealsClick}
          onMouseOver={(e) => {
            e.target.style.color = '#fff';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseOut={(e) => {
            e.target.style.color = '#ccc';
            e.target.style.textDecoration = 'none';
          }}
        >
          Today's Deals
        </a>
        <span style={{ color: '#666', display: 'inline', fontSize: isMobile ? '10px' : '14px', padding: isMobile ? '0 2px' : '0' }}>|</span>
        <a 
          href="/contact" 
          style={{
            color: '#ccc',
            textDecoration: 'none',
            fontSize: isMobile ? '11px' : '14px',
            padding: isMobile ? '0 6px' : '0 10px',
            transition: 'all 0.2s ease',
            display: 'inline-block'
          }}
          aria-label="Contact us"
          onMouseOver={(e) => {
            e.target.style.color = '#fff';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseOut={(e) => {
            e.target.style.color = '#ccc';
            e.target.style.textDecoration = 'none';
          }}
        >
          Contact
        </a>
      </div>
      
      {/* Footer Bar */}
      <div className="global-footer-bar" style={{
        marginTop: '12px',
        padding: '12px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: theme.isDarkMode ? '#121212' : '#1a1a1a',
        color: 'rgba(255,255,255,0.7)',
        fontSize: isMobile ? '12px' : '14px',
        fontWeight: '300',
        width: '100%',
        boxSizing: 'border-box',
        borderTop: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div style={{ textAlign: 'center', lineHeight: '1.4' }}>
          <div>© {new Date().getFullYear()} Angler Built · A Division of Alex Timm Media, LLC</div>
          <div style={{ marginTop: '8px' }}>
            <a 
              href="/ask-question"
              style={{
                color: '#888',
                textDecoration: 'none',
                fontSize: isMobile ? '11px' : '13px',
                transition: 'color 0.2s ease',
                display: 'inline-block'
              }}
              onMouseOver={(e) => {
                e.target.style.color = '#ccc';
                e.target.style.textDecoration = 'underline';
              }}
              onMouseOut={(e) => {
                e.target.style.color = '#888';
                e.target.style.textDecoration = 'none';
              }}
            >
              💬 Spot a bug or have an idea? Tell me.
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer; 